/**
 * Қазақша.
 *
 * Kept in its own file for the same reason as Turkish: a bundle is three
 * hundred strings. Cyrillic, which is what Kazakh is written in on phones
 * today. Keys must match en exactly — anything missing falls back to English
 * rather than showing the key.
 */
export const kk = {
  'app.name': 'Pine',
  'app.tagline': 'Серверсіз мессенджер',
  'nav.chats': 'Чаттар',
  'nav.channels': 'Арналар',
  'nav.contacts': 'Контактілер',
  'nav.settings': 'Баптаулар',

  'onboard.welcome': 'Pine-ге қош келдіңіз',
  'onboard.lede': 'Хабарламалар құрылғылар арасында тікелей жүреді. Аккаунт та, телефон нөмірі де, жазбаларыңызды сақтайтын сервер де жоқ.',
  'onboard.create': 'Профиль жасау',
  'onboard.restore': 'Менде қалпына келтіру кілті бар',
  'onboard.name': 'Сізді қалай атаймыз?',
  'onboard.namePlaceholder': 'Аты немесе лақап аты',
  'onboard.username': 'Пайдаланушы атын таңдаңыз',
  'onboard.usernameLede': 'Сізді ұзын кілтсіз осы ат арқылы табады. Өткізіп жіберіп, кейін де қоюға болады.',
  'onboard.usernameSkip': 'Өткізу',
  'access.title': 'Соңғы қадам: рұқсаттар',
  'access.lede': 'Android қарамайтын қолданбаларды ұйқыға жібереді. Бұл рұқсаттарсыз қоңыраулар мен хабарламалар тек Pine экранда ашық тұрғанда келеді.',
  'access.notifications': 'Хабарландырулар',
  'access.notificationsWhy': 'Болмаса қоңырау мен хабарлама туралы ешкім ескертпейді',
  'access.battery': 'Фонда жұмыс',
  'access.batteryWhy': 'Батарея үнемдеуден босату — онсыз байланыс бірнеше минуттан кейін үзіледі',
  'access.fullScreen': 'Толық экранды қоңырау',
  'access.fullScreenWhy': 'Кіріс қоңырау құлып экранының үстінде көрінуі үшін',
  'access.allow': 'Рұқсат беру',
  'access.done': 'Дайын',
  'access.anyway': 'Онсыз жалғастыру',
  'access.needNotifications': 'Хабарландыруларсыз әрі қарай болмайды: қолданба сізге қоңырау туралы айта алмайды.',
  'access.partial': 'Кейбір рұқсаттар берілмеді — қолданба жабық кезде қоңыраулар жетпеуі мүмкін. Оларды кейін баптауларда беруге болады.',
  'onboard.continue': 'Жалғастыру',
  'onboard.keyTitle': 'Қалпына келтіру кілтін сақтаңыз',
  'onboard.keyLede': 'Профильге басқа құрылғыдан кірудің жалғыз жолы осы. Оны ешкім қалпына келтіре алмайды — көшірмесін сақтайтын сервер жоқ.',
  'onboard.keyCopied': 'Қалпына келтіру кілті көшірілді',
  'onboard.keySaved': 'Сақтадым',
  'onboard.restoreTitle': 'Профильді қалпына келтіру',
  'onboard.restoreLede': 'Профильді жасаған кезде сақтаған қалпына келтіру кілтін енгізіңіз.',
  'onboard.restoreAction': 'Қалпына келтіру',
  'onboard.back': 'Артқа',

  'chats.title': 'Чаттар',
  'chats.search': 'Іздеу',
  'chats.empty': 'Әзірге бос',
  'chats.emptyHint': 'Топ не арна құрыңыз немесе Pine ID арқылы жеке чат бастаңыз.',
  'chats.all': 'Барлығы',
  'chats.unread': 'Оқылмаған',
  'chats.groups': 'Топтар',
  'chats.channels': 'Арналар',
  'chats.direct': 'Жеке',
  'chats.archived': 'Мұрағат',
  'chats.saved': 'Таңдаулы',
  'restore.title': 'Жазбалар әлі жүктелмеген',
  'link.addDevice': 'Басқа құрылғыдағы QR арқылы кіру',
  'link.title': 'QR арқылы кіру',
  'link.lede': 'Кіріп қойған құрылғыңызда Баптаулар → Құрылғылар → Құрылғы қосу бөлімін ашып, осы кодты сканерлеңіз.',
  'link.orCode': 'Немесе кодты көшіріп, сонда қойыңыз:',
  'link.waiting': 'Растауды күтудеміз…',
  'link.expired': 'Кодтың мерзімі бітті. Қайта көріңіз.',
  'devices.title': 'Құрылғылар',
  'devices.empty': 'Әзірге тек осы құрылғы.',
  'devices.unnamed': 'Құрылғы',
  'devices.current': 'осы құрылғы',
  'devices.revoke': 'Ажырату',
  'devices.revoked': 'Құрылғы ажыратылды',
  'devices.add': 'Құрылғы қосу',
  'devices.addHint': 'Жаңа құрылғыдағы QR кодты сканерлеңіз',
  'devices.addAction': 'Жалғастыру',
  'devices.scanLede': 'Камераны жаңа құрылғы көрсетіп тұрған QR кодқа бағыттаңыз.',
  'devices.pasteLabel': 'Немесе сол құрылғыдағы кодты қойыңыз',
  'devices.linked': 'Құрылғы қосылды',
  'devices.linking': 'Жіберілуде…',
  'devices.confirmTitle': 'Аккаунт осы құрылғыға берілсін бе?',
  'devices.confirmBody': 'Ол аккаунтыңызға және ондағы бәріне толық қол жеткізеді. Мұны құрылғы өзіңіздікі болса әрі кодты сол көрсетіп тұрса ғана жасаңыз.',
  'devices.confirmAction': 'Беру',
  'devices.warning': 'Ажырату құрылғыны тізімнен шығарады, адал клиент аккаунттан өзі шығады. Бірақ аккаунт кілті онда қалады — құрылғы бөтен қолда болса, шынымен көмектесетіні тек жаңа аккаунт.',
  'restore.action': 'Қалпына келтіру',
  'restore.asking': 'Қатысушылардан сұралуда…',
  'restore.asked': 'Сұралды: {n}',
  'restore.nobodyOnline': 'Қатысушылардың ешқайсысы желіде жоқ. Кейінірек көріңіз.',
  'restore.hint': 'Атауы мен құрамы серверден келді. Жазбаларды қатысушылардың өзі береді.',
  'restore.section': 'Қалпына келтіру',
  'restore.sectionHint': 'Осы құрылғыда жоқ нәрсені қатысушылардан сұраңыз: тарихты немесе жазу құқығын.',
  'restore.nothingMissing': 'Бұл чатта жетіспейтін ештеңе жоқ',
  'attach.title': 'Тіркеу',
  'attach.media': 'Фото және видео',
  'attach.music': 'Музыка',
  'attach.documents': 'Құжаттар',
  'attach.files': 'Файлдар',
  'attach.poll': 'Сауалнама',
  'attach.unreadable': 'Оқылмаған файл саны: {n}',
  'attach.pickerFailed': 'Файл таңдау терезесі ашылмады',
  'poll.title': 'Жаңа сауалнама',
  'poll.question': 'Сұрақ',
  'poll.questionPlaceholder': 'Не сұраймыз?',
  'poll.options': 'Жауап нұсқалары',
  'poll.optionPlaceholder': 'Нұсқа',
  'poll.optionMore': 'Нұсқа қосу',
  'poll.optionsHint': 'Жаңа жол өзі пайда болады. Enter келесісіне өткізеді.',
  'poll.limit': 'Сауалнамада бұдан көп нұсқа болмайды.',
  'poll.anonymous': 'Жасырын дауыс беру',
  'poll.multiple': 'Бірнеше жауап',
  'poll.anonymousNote': 'Жасырын сауалнама',
  'poll.noVotes': 'Әзірге дауыс жоқ',
  'poll.create': 'Құру',
  'chats.you': 'Сіз',
  'chats.draft': 'Нобай',

  'new.title': 'Жаңа чат',
  'new.group': 'Топ',
  'new.groupHint': 'Бәрі жаза алатын ортақ чат',
  'new.channel': 'Арна',
  'new.channelHint': 'Әкімшілер жариялайды, қалғаны оқиды',
  'new.direct': 'Жеке чат',
  'new.directHint': 'Pine ID арқылы бетпе-бет',
  'new.join': 'Сілтеме арқылы қосылу',
  'new.joinHint': 'Шақыруды қойыңыз',
  'new.name': 'Атауы',
  'new.namePlaceholder': 'Мысалы, Pine командасы',
  'new.description': 'Сипаттама',
  'new.create': 'Құру',
  'new.peerId': 'Әңгімелесушінің Pine ID-і',
  'new.start': 'Бастау',
  'new.invitePlaceholder': 'https://papi.olshub.xyz/i/… немесе код',

  'conv.placeholder': 'Хабарлама',
  'conv.placeholderChannel': 'Арнаға жазу',
  'conv.readOnly': 'Мұнда тек әкімшілер жаза алады',
  'conv.notWritable': 'Бөлмеге жазу құқығын күтудеміз…',
  'conv.askAccess': 'Қайта сұрау',
  'conv.queueing': 'Чат бұл құрылғыны әлі растап жатыр. Жаза беріңіз: қатысушылардың бірі желіге шыққанда хабарламалар жіберіледі.',
  'settings.contactDev': 'Әзірлеушіге жазу',
  'settings.contactDevHint': 'Сұрақтар, қателер, ұсыныстар',
  'contactDev.lede': 'Сұрақтар, қателер мен ұсыныстар — әзірлеушінің поштасына:',
  'contactDev.copy': 'Мекенжайды көшіру',
  'contactDev.write': 'Хат жазу',
  'stories.mute': 'Дыбысты өшіру',
  'stories.unmute': 'Дыбысты қосу',
  'conv.sending': 'Жіберілуде…',
  'bot.label': 'бот',
  'bot.start': 'Бастау',
  'bot.commands': 'Бот командалары',
  'bot.addToGroup': 'Топқа қосу',
  'bot.addTitle': '{name} топқа қосу',
  'bot.add': 'Қосу',
  'bot.added': '«{name}» шақыруы жіберілді',
  'bot.addFailed': 'Жеткізілмеді: алушы қазір желіде емес. Оның орнына шақыру сілтемесін жіберуге болады.',
  'bot.noGroups': 'Шақыра алатын топтарыңыз жоқ',
  'assistant.subtitle': 'ЖИ-көмекші',
  'assistant.denied': 'ЖИ-көмекшіні пайдалану үшін әзірлеушіге хабарласыңыз.',
  'assistant.copyId': 'Pine ID-імді көшіру',
  'assistant.idCopied': 'Pine ID көшірілді — оны әзірлеушіге жіберіңіз',
  'assistant.connecting': 'Аня қосылуда — чат бірнеше секундтан кейін жұмыс істейді.',
  'action.send': 'Жіберу',
  'stories.me': 'Мен',
  'stories.mine': 'Менің оқиғам',
  'stories.add': 'Оқиға қосу',
  'stories.title': 'Жаңа оқиға',
  'stories.caption': 'Қолтаңба — міндетті емес',
  'stories.publish': 'Жариялау',
  'stories.published': 'Оқиға 24 сағатқа жарияланды',
  'stories.failed': 'Жариялау мүмкін болмады',
  'stories.audience': 'Жеке чатыңыз бар барлық адам көреді. 24 сағаттан кейін жоғалады. Pine сервері оны тек шифрланған түрде сақтайды.',
  'stories.tooBig': 'Файл тым үлкен: оқиға үшін — 24 МБ-қа дейін',
  'stories.tooLong': 'Оқиғаға арналған бейне — бір минуттан аспауы керек',
  'stories.unsupported': 'Оқиғаға фото немесе бейне қосуға болады',
  'stories.unreadable': 'Бұл фотоны ашу мүмкін болмады',
  'stories.reply': 'Жауап беру…',
  'stories.sent': 'Жеке чатқа жіберілді',
  'stories.play': 'Жалғастыру',
  'stories.pause': 'Кідірту',
  'stories.gone': 'Бұл оқиға енді қолжетімсіз',
  'stories.viewsTitle': 'Қаралым: {n}',
  'stories.noViews': 'Әзірге ешкім қарамады',
  'stories.delete': 'Жою',
  'stories.deleteConfirm': 'Бұл оқиғаны барлығынан жою керек пе?',
  'stories.deleted': 'Оқиға жойылды',
  'stories.replyHeader': 'Оқиғаға жауап',
  'stories.reactedHeader': 'Оқиғаға реакция',
  'badge.bot': 'Бот',
  'contacts.inviteTo': '«{name}» тобына шақырады',
  'conv.empty': 'Әзірге хабарлама жоқ',
  'conv.emptyHint': 'Біріншісін жазыңыз — ол тікелей қатысушыларға кетеді.',
  'conv.awaitingPeer': 'Шақыру жіберілуде. {name} Pine-ді ашқанда чатты көреді — қазір де жаза бересіз.',
  'conv.thatPerson': 'Әңгімелесуші',
  'conv.selectChat': 'Чат таңдаңыз',
  'conv.selectChatHint': 'Немесе чаттар тізімінің үстіндегі «+» түймесімен жаңасын бастаңыз.',
  'chats.noMessages': 'Әзірге хабарлама жоқ',
  'conv.edited': 'өзгертілді',
  'conv.deleted': 'Хабарлама жойылды',
  'conv.attachmentGone': 'Бұл файл енді ешкімде жоқ',
  'media.loading': 'Жүктелуде…',
  'media.waiting': 'Жіберуші желіге кіргенде келеді',
  'media.tapToLoad': 'Жүктеу үшін басыңыз',
  'invite.group': 'Топқа шақыру',
  'invite.channel': 'Арнаға шақыру',
  'invite.unnamed': 'Атаусыз',
  'invite.join': 'Қосылу',
  'invite.subscribe': 'Жазылу',
  'collect.title': 'Коллекциялық ат',
  'collect.kind': 'Pine операторы шығарған · мерзімі бітпейді',
  'collect.explain': 'Бұл сіздің пайдаланушы атыңыз болады. Оны ұзартудың қажеті жоқ, оны басқа ешкім ала алмайды.',
  'collect.replaces': 'Қазіргі {name} атыңыз босатылады.',
  'collect.take': 'Атты алу',
  'collect.done': 'Енді сіз — {name}',
  'collect.err.used': 'Бұл сілтеме қолданылып қойған.',
  'collect.err.unknown': 'Сілтеме жарамсыз немесе аттар серверіне қол жетпейді.',
  'collect.err.taken': 'Бұл ат бос емес.',
  'collect.err.frozen': 'Аккаунт тоқтатылған, ат ала алмайды.',
  'collect.err.offline': 'Аттар серверіне қосылу жоқ. Кейінірек көріңіз.',
  'collect.err.failed': 'Атты алу мүмкін болмады.',
  'settings.linkPreviews': 'Сілтеме алдын ала көрінісі',
  'settings.linkPreviewsHint': 'Хабарламадағы сілтеменің тақырыбы мен суреті. Бетті Pine сервері жүктейді — ол мекенжайды біледі, чатты не алушыны емес.',
  'conv.reply': 'Жауап беру',
  'conv.edit': 'Өзгерту',
  'conv.delete': 'Жою',
  'conv.copy': 'Мәтінді көшіру',
  'conv.forward': 'Қайта жіберу',
  'conv.pin': 'Бекіту',
  'conv.unpin': 'Бекітуді алу',
  'conv.replyTo': 'Жауап',
  'conv.editing': 'Өзгерту',
  'conv.pinned': 'Бекітілген',
  'conv.jumpToLatest': 'Соңғыларға өту',
  'conv.loadOlder': 'Ертеректегілерін көрсету',
  'conv.deleteConfirm': 'Хабарлама бәрінен жойылсын ба?',
  'conv.deleteForAll': 'Бәрінен жою',
  'conv.cancel': 'Болдырмау',
  'conv.typing': 'жазып жатыр…',
  'conv.typingMany': 'жазып жатыр…',
  'conv.online': 'желіде',
  'conv.membersOnline': '{online} желіде',
  'conv.recording': 'Дауыстық хабарлама жазылуда',
  'emoji.search': 'Эмодзи іздеу',
  'emoji.none': 'Ештеңе табылмады',
  'emoji.cat.recent': 'Жуықтағылар',
  'emoji.cat.smileys': 'Смайлдар мен эмоциялар',
  'emoji.cat.people': 'Адамдар және қимылдар',
  'emoji.cat.nature': 'Жануарлар мен табиғат',
  'emoji.cat.food': 'Тамақ пен сусын',
  'emoji.cat.travel': 'Саяхат және орындар',
  'emoji.cat.activities': 'Іс-әрекеттер',
  'emoji.cat.objects': 'Заттар',
  'emoji.cat.symbols': 'Таңбалар',
  'conv.slideToCancel': 'Жіберу үшін қоя беріңіз',

  'sys.join': '{name} чатқа қосылды',
  'sys.leave': '{name} чаттан шықты',
  'sys.kick': '{name} чаттан шығарылды',
  'sys.role': '{name} енді {role}',
  'sys.callEnded': 'Қоңырау, {duration}',
  'sys.callMissed': 'Жауапсыз қоңырау',
  'sys.callNoAnswer': 'Жауап берілмеген қоңырау',
  'sys.callDeclined': 'Қоңырау қабылданбады',

  'panel.info': 'Ақпарат',
  'panel.members': 'Қатысушылар',
  'panel.media': 'Медиа',
  'panel.files': 'Файлдар',
  'panel.links': 'Сілтемелер',
  'panel.invite': 'Шақыру',
  'panel.inviteLink': 'Шақыру сілтемесі',
  'panel.newInvite': 'Сілтеме жасау',
  'panel.copyLink': 'Сілтемені көшіру',
  'panel.revoke': 'Кері қайтару',
  'panel.notifications': 'Хабарландырулар',
  'panel.mute': 'Дыбыссыз',
  'panel.pinChat': 'Чатты бекіту',
  'panel.archive': 'Мұрағатқа',
  'panel.leave': 'Чаттан шығу',
  'panel.leaveConfirm': 'Чаттан шығасыз ба? Тарих осы құрылғыда қалады.',
  'panel.permissions': 'Құқықтар',
  'panel.readOnly': 'Тек оқу',
  'panel.membersCanInvite': 'Қатысушылар шақыра алады',
  'panel.reactions': 'Реакциялар',
  'panel.disappearing': 'Жоғалатын хабарламалар',
  'panel.noMedia': 'Әзірге медиа жоқ',
  'panel.makeAdmin': 'Әкімші ету',
  'panel.makeModerator': 'Модератор ету',
  'panel.makeMember': 'Қатысушы ету',
  'panel.removeMember': 'Чаттан шығару',
  'panel.copyId': 'Pine ID-ін көшіру',

  'role.owner': 'Иесі',
  'role.admin': 'Әкімші',
  'role.moderator': 'Модератор',
  'role.member': 'Қатысушы',
  'role.restricted': 'Шектеулі',

  'frozen.title': 'Аккаунт тоңазытылған.',
  'frozen.body': 'Әкімшілік оны шектеді: жаңа чат ашуға және жаңа чатқа кіруге болмайды, сізді табу да мүмкін емес. Барлық бұрынғы чаттар әдеттегідей жұмыс істейді.',
  'frozen.self': 'Аккаунт тоңазытылған: жаңа чат ашуға болмайды. Бұрынғылары жұмыс істейді.',
  'frozen.peer': 'Бұл аккаунт тоңазытылған — онымен жаңа чат бастауға болмайды.',

  'report.title': 'Шағымдану',
  'report.action': 'Шағымдану',
  'report.user': 'Пайдаланушыға шағымдану',
  'report.userSub': 'Жазысу қолдау қызметіне жіберіледі',
  'report.reason': 'Себебі',
  'report.reason.spam': 'Спам',
  'report.reason.abuse': 'Балағат сөз немесе қорқыту',
  'report.reason.fraud': 'Алаяқтық',
  'report.reason.illegal': 'Тыйым салынған мазмұн',
  'report.reason.other': 'Басқа',
  'report.note': 'Не болды',
  'report.notePlaceholder': 'Міндетті емес, бірақ көмектеседі',
  'report.send': 'Шағым жіберу',
  'report.sent': 'Шағым жіберілді',
  'report.failed': 'Шағым жіберілмеді. Кейінірек көріңіз.',
  'report.sendsMessage': 'Серверге осы хабарлама, Pine ID-іңіз және себебі жіберіледі — басқа ешнәрсе.',
  'report.sendsChat': 'Осы чаттың соңғы 100 хабарламасы серверге ашық мәтінмен жіберіледі, оны әкімшілік оқи алады. Әдетте Pine-дағы жазысуды әңгімелесушілерден басқа ешкім көрмейді — бұл жалғыз ерекшелік, әрі тек сіз түймені басқанда болады.',

  'settings.title': 'Баптаулар',
  'settings.profile': 'Профиль',
  'avatar.change': 'Суретті ауыстыру',
  'avatar.remove': 'Суретті өшіру',
  'avatar.updated': 'Сурет жаңартылды',
  'avatar.failed': 'Бұл суретті өңдеу мүмкін болмады',
  'avatar.notImage': 'Бұл сурет емес',
  'badge.verified': 'Расталған аккаунт',
  'badge.tester': 'Бета-тестілеуші',
  'badge.donor': 'Жобаны қолдады',
  'badge.translator': 'Аудармашы',
  'settings.badges': 'Белгілер',
  'settings.badgeAlways': 'Әрқашан көрінеді',
  'settings.badgesHint': 'Белгілер атыңыздың жанында басқаларға көрінеді. Оларды серверді басқарушы береді. «Расталған аккаунттан» басқасын жасыруға болады: ол біреудің сіздің атыңызды жамылуына жол бермеу үшін керек.',
  'settings.badgeFailed': 'Сақталмады — сервер қолжетімсіз',
  'settings.badgeRefused': 'Сақталмады: сервер сұрауды қабылдамады',
  'settings.name': 'Аты',
  'settings.bio': 'Өзі туралы',
  'settings.username': 'Пайдаланушы аты',
  'settings.usernameHint': 'Ұзын ID орнына @ат арқылы сізді таба алады.',
  'settings.usernamePlaceholder': 'мысалы, alex',
  'settings.usernameFree': 'Желіде жарияланған',
  'settings.usernameNone': 'Қойылмаған',
  'name.err.emoji': 'Атта эмодзи қолданылмайды',
  'username.err.short': 'Кемінде 3 таңба',
  'username.err.long': 'Ең көбі 32 таңба',
  'username.err.charset': 'Тек латын әрпі, сан және астыңғы сызық',
  'username.err.underscore': 'Астыңғы сызықтан басталмайды және аяқталмайды',
  'username.err.empty': 'Ат енгізіңіз',
  'username.err.taken': 'Бұл ат бос емес — басқасын көріңіз',
  'username.err.offline': 'Ат сервері қолжетімсіз. Кейінірек көріңіз.',
  'username.err.failed': 'Бұл атты алу мүмкін болмады',
  'username.err.stale': 'Құрылғының уақыты қате — сағатты тексеріңіз',
  'username.err.slow_down': 'Тым көп әрекет. Бір минут күтіңіз.',
  'settings.usernameTaken': 'Бос емес',
  'settings.usernameChecking': 'Тексерілуде…',
  'settings.usernameReserved': 'Сізге сақталған',
  'search.byUsername': '@ат немесе Pine ID арқылы іздеу',
  'search.searching': 'Ізделуде…',
  'search.notFound': 'Бұл атқа ешкім жауап бермейді. Желіде болмауы мүмкін.',
  'search.found': 'Табылды',
  'search.collision': 'Бұл атты бірнеше адам жариялаған. ID-лерін тексеріңіз.',
  'search.hint': 'Ат бір адамға тиесілі. Ат сервері қолжетімсіз болса, іздеу желіге ауысады да бірнешеуін табуы мүмкін.',
  'contacts.username': 'Пайдаланушы аты',
  'settings.yourId': 'Сіздің Pine ID',
  'settings.idHint': 'Сізге жазғысы келетін кез келген адамға беріңіз.',
  'settings.appearance': 'Сыртқы түрі',
  'settings.theme': 'Тема',
  'settings.themeSystem': 'Жүйедегідей',
  'settings.themeLight': 'Ашық',
  'settings.themeDark': 'Қою',
  'settings.language': 'Тіл',
  'settings.notifications': 'Хабарландырулар',
  'settings.notificationsGroup': 'Хабарландырулар мен дыбыстар',
  'settings.chatsGroup': 'Чаттар мен медиа',
  'settings.keysGroup': 'Кілт және шығу',
  'settings.notificationsCalls': 'Хабарландырулар мен қоңыраулар',
  'settings.chatsAppearance': 'Чаттар мен безендіру',
  'settings.privacySecurity': 'Құпиялық және қауіпсіздік',
  'settings.bgAttention': 'Қоңыраулар жетпеуі мүмкін: рұқсаттарды тексеріңіз',
  'settings.notificationsOn': 'Хабарландыруларды көрсету',
  'settings.sound': 'Дыбыс',
  'settings.autostart': 'Жүйемен бірге іске қосу',
  'settings.autostartHint': 'Компьютерді телефон сияқты серверден оята алмайсыз: хабарламалар мен қоңыраулар Pine іске қосылып тұрғанда ғана келеді. Ол терезесіз, жүйелік науада іске қосылады.',
  'settings.privacy': 'Құпиялылық',
  'settings.readReceipts': 'Оқылғаны туралы белгі',
  'settings.typingIndicators': '«Жазып жатыр» күйін көрсету',
  'settings.enterToSend': 'Enter хабарламаны жібереді',
  'settings.autoDownload': 'Медианы автожүктеу',
  'settings.backupKeys': 'Чаттардың сақтық көшірмесі',
  'settings.backupKeysHint': 'Чат кілттері серверде шифрланып жатады — сол себепті жаңа құрылғыда чаттар бірден қайта оралады. Өшірсеңіз, кілттер қатысушылардан сұралады.',
  'settings.calls': 'Қоңыраулар',
  'settings.telecom': 'Android жүйелік қоңыраулары',
  'settings.telecomHint': 'Қоңыраулар телефонның өз қоңырау қызметі арқылы өтеді: сенімдірек келеді, гарнитурадан және көліктен жауап беруге болады. Телефоныңызда ақау шықса, өшіріңіз.',
  'pro.home': 'Аня үшін көбірек модель және үлкенірек шектер',
  'pro.active': '{date} дейін белсенді',
  'pro.ended': '{date} аяқталды',
  'pro.inactive': 'Рәсімделмеген',
  'pro.unavailable': 'Сервер қазір жауап бермей тұр, кейінірек қайталаңыз',
  'pro.what': 'Жазылым не береді',
  'pro.plain': 'Әдеттегі',
  'pro.perDay': 'Күніне сұрақ',
  'pro.perMonth': 'Айына сұрақ',
  'pro.images': 'Күніне сурет',
  'pro.models': 'Қосымша модельдер',
  'pro.get': 'Рәсімдеу',
  'pro.extend': 'Ұзарту',
  'pro.howTo': 'Жазылымды әзірлеуші рәсімдейді. Батырманы басыңыз: хатта Pine ID-іңіз бұрыннан болады. Сізге қалай төлеу керегін айтып, Pro-ны қосады.',
  'pro.contactLede': 'Әзірлеушіге Pine AI Pro рәсімдегіңіз келетінін жазыңыз. Ол қалай төлеу керегін айтып, Pine ID-іңізге жазылымды қосады.',
  'pro.contactBody': 'Сәлеметсіз бе! Pine AI Pro рәсімдегім келеді.',
  'settings.ringFromPush': 'Қоңырау бірден сервер арқылы',
  'settings.ringFromPushHint': 'Сервер қоңырауды жеткізген бойда телефон шырылдайды, қоңырау шалушымен байланысты күтпейді. Бұл кезде сервер мен Google сізге кім қоңырау шалып жатқанын көреді (тек ID, әңгіме емес).',
  'settings.ringtone': 'Қоңырау әуені',
  'settings.ringtonePine': 'Pine',
  'settings.ringtoneSystem': 'Құрылғыдағыдай',
  'settings.ringtonePick': 'Құрылғыдан таңдау…',
  'settings.background': 'Фондағы жұмыс',
  'settings.backgroundHint': 'Қоңыраулар мен хабарламалар Pine фонда жұмыс істеп тұрғанда ғана келеді. Бұлардың бірі рұқсат етілмесе, кіріс қоңыраулар жетпей қалуы мүмкін.',
  'settings.push': 'Pine жабық кезде оны ояту',
  'settings.pushHint': 'Сервер Google арқылы бос белгі жібереді — «қоңырау» немесе «жаңа нәрсе бар», — Pine оянып, бәрін өзі шифрлап алады. Белгіде мәтін де, жіберуші де жоқ. Өшірсеңіз, жабық қолданба келесі іске қосылғанға дейін ештеңе алмайды.',
  'web.notifyTitle': 'Браузер хабарландырулары',
  'web.notifyHint': 'Қоңыраулар мен хабарламалар — Pine қойындысы жабық болса да',
  'web.notifyBlocked': 'Браузерде тыйым салынған',
  'web.notifyOn': 'Хабарландырулар қосылды',
  'web.notifyBanner': 'Хабарландыруларды қосыңыз — әйтпесе жабық қойынды қоңырау туралы білмейді.',
  'web.notifyInstall': 'iPhone-да хабарландырулар тек «Басты экрандағы» Pine-ға келеді: «Бөлісу» → «Басты экранға қосу», содан кейін Pine-ды сол жерден ашыңыз.',
  'web.installRelogin': 'Онда тағы бір рет кіру керек: Safari мен «Басты экрандағы» белгіше деректерді бөлек сақтайды. Белгішедегі Pine-да «Басқа құрылғыдағы QR арқылы кіру» таңдаңыз, кодты көшіріп, осында қойыңыз: Баптаулар → Құрылғылар → «Құрылғы қосу».',
  'keysave.save': 'Кілтті браузерге сақтау',
  'keysave.signIn': 'Сақталған кілтпен кіру',
  'keysave.fill': 'Браузердегі кілтті алу',
  'settings.bgNotifications': 'Хабарландырулар',
  'settings.bgBattery': 'Батарея шектеуінсіз',
  'settings.bgFullScreen': 'Толық экранды қоңырау',
  'settings.bgAllowed': 'Рұқсат етілген',
  'settings.bgFix': 'Рұқсат беру',
  'settings.bgUnrestricted': 'Фондық жұмыс шектелмеген',
  'settings.bgJournal': 'Фондық жұмыс журналы',
  'settings.bgJournalHint': 'Қоңырау жетпесе, журналды әзірлеушіге жіберіңіз. Онда тек оқиғалардың уақыты бар, хабарламалардың мазмұны жоқ.',
  'settings.bgJournalSend': 'Жіберу',
  'settings.network': 'Желі',
  'settings.connection': 'Байланыс',
  'settings.peers': 'Қосылған тораптар',
  'settings.mode': 'Режим',
  'settings.modeNative': 'Тікелей тораптар арасында',
  'settings.modeRelay': 'Ретранслятор арқылы',
  'settings.account': 'Профиль және кілттер',
  'settings.recoveryKey': 'Қалпына келтіру кілті',
  'settings.showKey': 'Кілтті көрсету',
  'settings.hideKey': 'Жасыру',
  'settings.storage': 'Жад',
  'settings.about': 'Қосымша туралы',
  'settings.signOut': 'Аккаунттан шығу',
  'settings.signOutHint': 'Бұл аккаунтты осы құрылғыдан өшіру',
  'settings.signOutConfirm': 'Шығу және өшіру',
  'settings.signOutWarning': 'Pine аккаунты тек осы құрылғыда тұрады — оны ешбір сервер сақтамайды. Шығу профильді, чаттарды және баптауларды өшіреді. Бұл аккаунтқа қайта кірудің жалғыз жолы — қалпына келтіру кілті.',
  'settings.signOutCopyKey': 'Қалпына келтіру кілтін көшіру',
  'settings.signOutNeedKey': 'Жалғастыру үшін кілтті көшіріңіз.',
  'update.title': '{version} нұсқасы шықты',
  'update.sub': 'Жаңарту қолмен жасалады — жүктеу бетінен.',
  'update.action': 'Жаңарту',
  'settings.save': 'Сақтау',
  'settings.saved': 'Сақталды',

  'contacts.title': 'Контактілер',
  'contacts.empty': 'Әзірге контакт жоқ',
  'contacts.emptyHint': 'Чат бастау үшін біреуді Pine ID арқылы қосыңыз.',
  'contacts.add': 'Контакт қосу',
  'contacts.requests': 'Сұраулар',
  'contacts.accept': 'Қабылдау',
  'contacts.decline': 'Бас тарту',
  'contacts.block': 'Бұғаттау',
  'contacts.unblock': 'Бұғаттан шығару',
  'contacts.blocked': 'Бұғатталған',
  'block.sub': 'Оның хабарларын, сұрауларын, қоңырауларын және оқиғаларын көрсетпеу',
  'block.blockedSub': 'Оның жаңа хабарлары, қоңыраулары мен оқиғалары көрсетілмейді',
  'block.confirm': 'Pine {name} жіберген жаңа хабарларды, сұраулар мен қоңырауларды көрсетпейді, оның оқиғаларын жасырады және сіздікін оған жібермейді. Ол бұл туралы білмейді. Бұғатты кез келген уақытта алуға болады.',
  'block.done': '{name} бұғатталды',
  'block.undone': '{name} бұғаттан шығарылды',
  'block.inChat': 'Сіз бұл адамды бұғаттадыңыз. Оның жаңа хабарлары көрсетілмейді.',
  'contacts.message': 'Хабарлама',
  'contacts.request': 'чат бастағысы келеді',

  'call.incoming': 'Кіріс қоңырау',
  'call.incomingVideo': 'Кіріс бейнеқоңырау',
  'call.calling': 'Шақырылуда…',
  'call.connecting': 'Қосылуда…',
  'call.accept': 'Қабылдау',
  'call.decline': 'Бас тарту',
  'call.hangUp': 'Аяқтау',
  'call.joining': 'Қоңырауға қосылудамыз…',
  'call.participants': 'қоңырауда {n} адам',
  'call.full': 'Қоңырауда орын қалмады',
  'call.unreachable': 'Қоңырау қосылмады. Бір жақтың желісі қоңырауларды өткізбейтін сияқты: басқа желіні немесе VPN-ді қолданып көріңіз.',
  'call.mute': 'Микрофон',
  'call.camera': 'Камера',
  'call.screen': 'Экран',
  'call.speaker': 'Динамик',
  'call.speakerOn': 'Қатты сөйлеткіш қосулы',
  'call.speakerOff': 'Қатты сөйлеткішті қосу',
  'call.flip': 'Басқа камера',
  'call.minimize': 'Қоңырауды кішірейту',
  'call.audioOutput': 'Дыбыс',
  'call.route.auto': 'Автоматты',
  'call.route.earpiece': 'Телефон динамигі',
  'call.route.speaker': 'Қатты сөйлеткіш',
  'call.route.bluetooth': 'Bluetooth',
  'call.route.wired': 'Сымды құлаққап',
  'call.ended': 'Қоңырау аяқталды',
  'call.unsupported': 'Бұл ортада қоңырау шалу мүмкін емес',

  'status.online': 'Желіде',
  'status.connecting': 'Қосылуда…',
  'status.reconnecting': 'Қайта қосылуда…',
  'status.offline': 'Желіден тыс',

  'time.now': 'жаңа ғана',
  'time.yesterday': 'кеше',
  'time.today': 'Бүгін',
  'time.yesterdayFull': 'Кеше',

  'err.generic': 'Бірдеңе дұрыс болмады',
  'err.invite': 'Бұл шақыруды оқу мүмкін болмады',
  'err.joinTimeout': 'Сізді кіргізетін ешкім желіде жоқ. Қатысушылардан Pine-ді ашуын сұраңыз.',
  'err.noPeer': 'Жету мүмкін болмады. Әңгімелесушінің Pine-і ашық тұруы керек.',
  'err.needName': 'Ат енгізіңіз',

  'action.copy': 'Көшіру',
  'action.copied': 'Көшірілді',
  'action.share': 'Бөлісу',
  'action.done': 'Дайын',
  'action.cancel': 'Болдырмау',
  'action.close': 'Жабу',
  'action.retry': 'Қайталау',
  'action.download': 'Жүктеу',
  'action.confirm': 'Растау'
}
